export default __webpack_public_path__ + "static/media/oval.9eb966a9.png";